import React from 'react';
import './App.css';
import Route from './app/route';
import 'semantic-ui-css/semantic.min.css'
function App() {
  return (
      <React.Fragment>
        <Route />
      </React.Fragment>
  );
}

export default App;
